export const plateCodeList = [
    { label: "A", value: "A" },
    { label: "A A", value: "A A" },
    { label: "A B", value: "A B" },
    { label: "A D", value: "A D" },
    { label: "A K", value: "A K" },
    { label: "A M", value: "A M" },
    { label: "A R", value: "A R" },
    { label: "A S", value: "A S" },
    { label: "A W", value: "A W" },
    { label: "A Y", value: "A Y" },
    { label: "Abu Dhabi", value: "Abu Dhabi" },
    { label: "Ajman", value: "Ajman" },
    { label: "B", value: "B" },
    { label: "B A", value: "B A" },
    { label: "B B", value: "B B" },
    { label: "B D", value: "B D" },
    { label: "B H", value: "B H" },
    { label: "B K", value: "B K" },
    { label: "B M", value: "B M" },
    { label: "B R", value: "B R" },
    { label: "B S", value: "B S" },
    { label: "B W", value: "B W" },
    { label: "B Y", value: "B Y" },
    { label: "Bahrain", value: "Bahrain" },
    { label: "BANK", value: "BANK" },
    { label: "C D", value: "C D" },
    { label: "D", value: "D" },
    { label: "D A", value: "D A" },
    { label: "D D", value: "D D" },
    { label: "D H", value: "D H" },
    { label: "D K", value: "D K" },
    { label: "D R", value: "D R" },
    { label: "D S", value: "D S" },
    { label: "D W", value: "D W" },
    { label: "D Y", value: "D Y" },
    { label: "Dubai", value: "Dubai" },
    { label: "Fujairah", value: "Fujairah" },
    { label: "H", value: "H" },
    { label: "H A", value: "H A" },
    { label: "H D", value: "H D" },
    { label: "H H", value: "H H" },
    { label: "H K", value: "H K" },
    { label: "H M", value: "H M" },
    { label: "H R", value: "H R" },
    { label: "H S", value: "H S" },
    { label: "H W", value: "H W" },
    { label: "H Y", value: "H Y" },
    { label: "IMPORT", value: "IMPORT" },
    { label: "Inspection", value: "Inspection" },
    { label: "I N T L", value: "I N T L" },
    { label: "J", value: "J" },
    { label: "K", value: "K" },
    { label: "K A", value: "K A" },
    { label: "K B", value: "K B" },
    { label: "K H", value: "K H" },
    { label: "K K", value: "K K" },
    { label: "KSA", value: "KSA" },
    { label: "Kuwait", value: "Kuwait" },
    { label: "L A", value: "L A" },
    { label: "L B", value: "L B" },
    { label: "L D", value: "L D" },
    { label: "L H", value: "L H" },
    { label: "L K", value: "L K" },
    { label: "M", value: "M" },
    { label: "M A", value: "M A" },
    { label: "M B", value: "M B" },
    { label: "M D", value: "M D" },
    { label: "M H", value: "M H" },
    { label: "M K", value: "M K" },
    { label: "M L", value: "M L" },
    { label: "M M", value: "M M" },
    { label: "M R", value: "M R" },
    { label: "M S", value: "M S" },
    { label: "M W", value: "M W" },
    { label: "M Y", value: "M Y" },
    { label: "MUSCAT", value: "MUSCAT" },
    { label: "Qatar", value: "Qatar" },
    { label: "R", value: "R" },
    { label: "R A", value: "R A" },
    { label: "R H", value: "R H" },
    { label: "R K", value: "R K" },
    { label: "R M", value: "R M" },
    { label: "R R", value: "R R" },
    { label: "R S", value: "R S" },
    { label: "R W", value: "R W" },
    { label: "R Y", value: "R Y" },
    { label: "Ras Al - Khaimah", value: "Ras Al - Khaimah" },
    { label: "S", value: "S" },
    { label: "S H", value: "S H" },
    { label: "S S", value: "S S" },
    { label: "Sharjah", value: "Sharjah" },
    { label: "T", value: "T" },
    { label: "T A", value: "T A" },
    { label: "T B", value: "T B" },
    { label: "T B A", value: "T B A" },
    { label: "T D", value: "T D" },
    { label: "T H", value: "T H" },
    { label: "T T", value: "T T" },
    { label: "UAE", value: "UAE" },
    { label: "Umm Al - Quwain", value: "Umm Al - Quwain" },
    { label: "W", value: "W" },
    { label: "W A", value: "W A" },
    { label: "W B", value: "W B" },
    { label: "W K", value: "W K" },
    { label: "W W", value: "W W" },
    { label: "Y", value: "Y" },
    { label: "Y A", value: "Y A" },
    { label: "Y B", value: "Y B" },
    { label: "Y D", value: "Y D" },
    { label: "Y M", value: "Y M" },
    { label: "Y R", value: "Y R" },
    { label: "Y S", value: "Y S" },
    { label: "Y W", value: "Y W" },
    { label: "Y Y", value: "Y Y" },

    // Numeric values at the end
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
    { label: "14", value: "14" },
    { label: "15", value: "15" },
    { label: "16", value: "16" },
    { label: "17", value: "17" },
    { label: "18", value: "18" },
    { label: "19", value: "19" },
    { label: "20", value: "20" },
    { label: "21", value: "21" },
    { label: "22", value: "22" },
    { label: "23", value: "23" },
    { label: "24", value: "24" },
    { label: "25", value: "25" },
    { label: "26", value: "26" },
    { label: "27", value: "27" },
    { label: "28", value: "28" },
    { label: "29", value: "29" },
    { label: "30", value: "30" },
    { label: "31", value: "31" },
    { label: "32", value: "32" },
    { label: "33", value: "33" },
    { label: "34", value: "34" },
    { label: "35", value: "35" },
    { label: "36", value: "36" },
    { label: "37", value: "37" },
    { label: "38", value: "38" },
    { label: "39", value: "39" },
    { label: "40", value: "40" },
    { label: "41", value: "41" },
    { label: "42", value: "42" },
    { label: "43", value: "43" },
    { label: "44", value: "44" },
    { label: "45", value: "45" },
    { label: "46", value: "46" },
    { label: "47", value: "47" },
    { label: "48", value: "48" },
    { label: "49", value: "49" },
    { label: "50", value: "50" },
    { label: "51", value: "51" },
    { label: "52", value: "52" },
    { label: "53", value: "53" },
    { label: "54", value: "54" },
    { label: "55", value: "55" },
    { label: "56", value: "56" },
    { label: "57", value: "57" },
    { label: "58", value: "58" },
    { label: "59", value: "59" },
    { label: "60", value: "60" },
    { label: "61", value: "61" },
    { label: "62", value: "62" },
    { label: "63", value: "63" },
    { label: "64", value: "64" },
    { label: "65", value: "65" },
    { label: "66", value: "66" },
    { label: "67", value: "67" },
    { label: "68", value: "68" },
    { label: "69", value: "69" },
    { label: "70", value: "70" },
    { label: "71", value: "71" },
    { label: "72", value: "72" },
    { label: "73", value: "73" },
    { label: "74", value: "74" },
    { label: "75", value: "75" },
    { label: "76", value: "76" },
    { label: "77", value: "77" },
    { label: "78", value: "78" },
    { label: "79", value: "79" },
    { label: "80", value: "80" },
    { label: "81", value: "81" },
    { label: "82", value: "82" },
    { label: "83", value: "83" },
    { label: "84", value: "84" },
    { label: "85", value: "85" },
    { label: "86", value: "86" },
    { label: "87", value: "87" },
    { label: "88", value: "88" },
    { label: "89", value: "89" },
    { label: "90", value: "90" },
    { label: "91", value: "91" },
    { label: "92", value: "92" },
    { label: "999", value: "999" }
];